module.exports = __webpack_public_path__ + "static/logo-e3781c79e8e203c009b4fe2e9c285561.png";